var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#EC6655"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66797 2.37221L4.91039 5.68595C4.91039 5.89564 5.03161 6.00049 5.27403 6.00049H6.72858C6.971 6.00049 7.09221 5.89564 7.09221 5.68595L7.33464 2.37221C7.33464 2.25784 7.29423 2.17205 7.21342 2.11486C7.15282 2.03861 7.07201 2.00049 6.971 2.00049H5.03161C4.9306 2.00049 4.83969 2.03861 4.75888 2.11486C4.69827 2.17205 4.66797 2.25784 4.66797 2.37221Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0013 7.33398C6.36845 7.33398 6.67763 7.46925 6.92884 7.73978C7.19937 7.99099 7.33464 8.30017 7.33464 8.66732C7.33464 9.03447 7.19937 9.35331 6.92884 9.62384C6.67763 9.87505 6.36845 10.0007 6.0013 10.0007C5.63415 10.0007 5.31531 9.87505 5.04478 9.62384C4.79357 9.35331 4.66797 9.03447 4.66797 8.66732C4.66797 8.30017 4.79357 7.99099 5.04478 7.73978C5.31531 7.46925 5.63415 7.33398 6.0013 7.33398Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon2);
export default __webpack_public_path__ + "static/media/warning-icon-2.b9d4b488ba75000381b527fae281edf5.svg";
export { ForwardRef as ReactComponent };